"use client"; // Error boundaries must be Client Components

import { useEffect } from "react";
import { useRollbar } from "@rollbar/react";
import { Box } from "@chakra-ui/react";
import { ErrorComponent } from "@/_components/ui/Error/Error";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const rollbar = useRollbar();

  useEffect(() => {
    console.error(error);
    rollbar.error(error);
  }, [error, rollbar]);

  return (
    <Box>
      <ErrorComponent onTryAgain={reset} />
    </Box>
  );
}
